module.exports = __webpack_public_path__ + "media/images/e-kvitok/bus_active-2252b3ceb9b0525f918eea69350b4154.svg";